import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Settings: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        System Settings
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          System configuration and settings interface coming soon...
        </Typography>
      </Paper>
    </Box>
  );
};

export default Settings;
